import React from 'react';
import { MobilePopupBottom } from '@lt/components';
import {
  TgLimitLogo,
  VkLimitLogo,
  WaLimitLogo,
} from '@lt/components/icons-react/communication';
import { i18n } from '@lt/localization';
import { NBSP } from 'src/constants/common';
import Popup from '../Popup';
import type { PopupComponentProps } from './types';
import styles from './TouristLimitModal.module.css';

const popupClassNames = {
  modal: styles.modalPopup,
  overlay: styles.bannerPopup,
};

const closeButtonStyles = {
  width: '20px',
  height: '16px',
  right: '9px',
  top: '7px',
  cursor: 'pointer',
};

const mobileBottomshitOptions = {
  showHandlebar: true,
};

export const TouristLimitModal = (props: PopupComponentProps) => {
  const { isMobile, isOpen, onClose } = props;
  return (
    <>
      {isMobile ? (
        <MobilePopupBottom
          onClick={onClose}
          visible={isOpen}
          options={mobileBottomshitOptions}
          className={styles.mobileContainer}
        >
          <div>
            <div className={styles.titleMobile}>
              {i18n.t('cigarettePreview.touristsLimitTitle', { nbsp: NBSP })}
            </div>
            <div className={styles.descriptionMobile}>
              {i18n.t('cigarettePreview.touristsLimitDescription')}
            </div>
            <ul className={styles.buttonsConatinerMobile}>
              <li className={styles.buttonMobile}>
                <a
                  className={styles.buttonMobileLink}
                  href="https://api.whatsapp.com/send?phone=79150424411"
                >
                  <div className={styles.iconWrapper}>
                    <WaLimitLogo />
                  </div>
                  <span className={styles.buttonMobileLinkText}>
                    {i18n.t('commonPhrases.socialNetworks.whatsapp')}
                  </span>
                </a>
              </li>
              <li className={styles.buttonMobile}>
                <a
                  className={styles.buttonMobileLink}
                  href="https://vk.com/im?sel=-29855322"
                >
                  <div className={styles.iconWrapper}>
                    <VkLimitLogo />
                  </div>
                  <span className={styles.buttonMobileLinkText}>
                    {i18n.t('commonPhrases.socialNetworks.vk')}
                  </span>
                </a>
              </li>
              <li className={styles.buttonMobile}>
                <a
                  className={styles.buttonMobileLink}
                  href="https://telegram.me/LevelTravelChatBot"
                >
                  <div className={styles.iconWrapper}>
                    <TgLimitLogo />
                  </div>
                  <span className={styles.buttonMobileLinkText}>
                    {i18n.t('commonPhrases.socialNetworks.telegram')}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </MobilePopupBottom>
      ) : (
        <Popup
          open={isOpen}
          onClose={onClose}
          classNames={popupClassNames}
          closeButtonStyles={closeButtonStyles}
        >
          <div>
            <div className={styles.titleDesktop}>
              {i18n.t('cigarettePreview.touristsLimitTitle', { nbsp: NBSP })}
            </div>
            <div className={styles.descriptionDesktop}>
              {i18n.t('cigarettePreview.touristsLimitDescription')}
            </div>
            <ul className={styles.buttonsConatiner}>
              <li className={styles.button}>
                <a
                  className={styles.buttonLink}
                  href="https://api.whatsapp.com/send?phone=79150424411"
                >
                  <div className={styles.iconWrapper}>
                    <WaLimitLogo />
                  </div>
                  <span className={styles.buttonLinkText}>
                    {i18n.t('commonPhrases.socialNetworks.whatsapp')}
                  </span>
                </a>
              </li>
              <li className={styles.button}>
                <a
                  className={styles.buttonLink}
                  href="https://vk.com/im?sel=-29855322"
                >
                  <div className={styles.iconWrapper}>
                    <VkLimitLogo />
                  </div>
                  <span className={styles.buttonLinkText}>
                    {i18n.t('commonPhrases.socialNetworks.vk')}
                  </span>
                </a>
              </li>
              <li className={styles.button}>
                <a
                  className={styles.buttonLink}
                  href="https://telegram.me/LevelTravelChatBot"
                >
                  <div className={styles.iconWrapper}>
                    <TgLimitLogo />
                  </div>
                  <span className={styles.buttonLinkText}>
                    {i18n.t('commonPhrases.socialNetworks.telegram')}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </Popup>
      )}
    </>
  );
};
